import React, { useState } from "react";
import backgroundIcon from "../../assets/images/background_icon.svg";
import { useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import toast from "react-hot-toast";
import { forgotPassword as sendResetLink } from "../../api/admin-users";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.trim()) {
      toast.error("Please enter an email address");
      return;
    }
    try {
      setSubmitting(true);
      const res = await sendResetLink({ email: email.trim() });
      if (res && res.error) {
        toast.error(res.message || "Failed to send reset link");
      } else {
        toast.success(res?.message || "Reset link sent to email");
        navigate("/");
      }
    } catch (err) {
      toast.error("Something went wrong. Try again");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="min-h-[75vh] max-h-[90vh] bg-white"
      style={{
        backgroundImage: `url(${backgroundIcon})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right",
      }}
    >
      <div className="max-w-6xl mx-auto px-4 my-auto min-h-[95vh] max-h-[100vh]">
        {/* Header */}
        <div className="pt-16 md:pt-24 text-center">
          <h1 className="text-2xl md:text-3xl font-bold">
            Forgot <span className="text-primary">Password</span>
          </h1>
          <p className="mt-2 text-sm text-gray-600">
            Enter the account <span className="font-medium">email</span> to receive a reset link.
          </p>
        </div>

        <div className="mt-10 flex justify-center">
          <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg ring-1 ring-gray-100 p-6 md:p-8">
            <form onSubmit={handleSubmit} className="space-y-5">
              {/* Email */}
              <div className="flex flex-col gap-2 w-full">
                <label htmlFor="email" className="text-sm font-medium text-gray-700">
                  Email
                </label>
                <InputText
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="example@domain.com"
                  className="!w-full rounded-md border border-slate-300 bg-white px-4 py-3 text-sm text-slate-700 placeholder-slate-400 focus:border-slate-400 focus:ring-2 focus:ring-slate-300 focus:outline-none transition"
                />
              </div>

              {/* Submit */}
              <Button
                type="submit"
                label={submitting ? "Sending..." : "Send Reset Link"}
                disabled={!email || submitting}
                className="w-full justify-center bg-primary text-white border-0 hover:bg-primary/90 transition py-1"
              />

              {/* Secondary action */}
              <Button
                type="button"
                label="Back to Login"
                onClick={() => navigate("/")}
                className="w-full justify-center bg-white text-slate-700 border border-slate-200 hover:bg-slate-50 transition py-1"
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
